import { render, staticRenderFns } from "./CreateKeywordsForm.vue?vue&type=template&id=7fea5832&scoped=true&"
import script from "./CreateKeywordsForm.vue?vue&type=script&lang=js&"
export * from "./CreateKeywordsForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateKeywordsForm.vue?vue&type=style&index=0&id=7fea5832&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fea5832",
  null
  
)

export default component.exports